import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "admin-header"
}
const _hoisted_2 = {
  key: 0,
  class: "buttons"
}
const _hoisted_3 = {
  key: 1,
  class: "available-lots-pop-up"
}
const _hoisted_4 = {
  key: 2,
  class: "stage-info-nav"
}
const _hoisted_5 = { class: "stage-available-lots" }
const _hoisted_6 = {
  key: 0,
  class: "zoom-info"
}
const _hoisted_7 = {
  key: 1,
  class: "legend"
}
const _hoisted_8 = { class: "status yellow" }
const _hoisted_9 = { class: "status warning" }
const _hoisted_10 = {
  key: 0,
  class: "legend"
}
const _hoisted_11 = { class: "status yellow" }
const _hoisted_12 = { class: "status warning" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["map-wr", { isBuilderView: $setup.props.builderView }]),
    onMousemove: $setup.handleMouseMove
  }, [
    ($setup.props.role === $setup.UserRoles.SUPER_ADMIN)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "title-main" }, "Map", -1)),
          ($setup.map !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (!$setup.map)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "button default primary add-btn-primary",
                      onClick: $setup.toCreateMap
                    }, "Add Map"))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("button", {
                        class: "button default outlined",
                        onClick: $setup.toEditMap
                      }, "Edit Map"),
                      _createElementVNode("button", {
                        class: "button default outlined warning",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showConfirmDeleteModal = true))
                      }, "Delete Map")
                    ], 64))
              ]))
            : _createCommentVNode("", true),
          _createVNode($setup["ConfirmDeleteModal"], {
            isOpen: $setup.showConfirmDeleteModal,
            deleteItem: 'stage map',
            onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.showConfirmDeleteModal = false)),
            onConfirm: $setup.deleteMap
          }, null, 8, ["isOpen"])
        ]))
      : _createCommentVNode("", true),
    ($setup.availableLotsPopUpShow && $setup.isDesktop && $setup.props.role === $setup.UserRoles.CUSTOMER && !$setup.isEmbeddedDesktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[8] || (_cache[8] = _createElementVNode("span", null, [
            _createTextVNode("Click "),
            _createElementVNode("strong", null, "Available"),
            _createTextVNode(" lots to view more information")
          ], -1)),
          _createElementVNode("div", {
            class: "close-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.availableLotsPopUpShow = false))
          })
        ]))
      : _createCommentVNode("", true),
    (!$setup.isDesktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", { class: "masterplan-btn-wr" }, [
            _createElementVNode("button", {
              class: "button-with-icon back",
              onClick: $setup.toMasterplan
            }, "BACK")
          ]),
          _createElementVNode("div", _hoisted_5, "Stage " + _toDisplayString($setup.lots[0]?.stageId.title) + ": " + _toDisplayString($setup.props.builderView ? $setup.props.lotsByHouseDesigns.length : $setup.getAvailableLots.length) + " lots available", 1),
          (!$props.builderView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Zoom in / out to view. Click any lot to view more info."))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["svg-wrapper", { isEmbeddedDesktop: $setup.isEmbeddedDesktop, isBuilderView: $setup.props.builderView }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["svg-container-map", { 'svg-map-embedded': $setup.isEmbeddedDesktop, isBuilderView: $setup.props.builderView }]),
        ref: "svgMapEmbedded"
      }, [
        ($setup.isEmbeddedDesktop)
          ? (_openBlock(), _createBlock($setup["MapSidePanel"], {
              key: 0,
              estateId: $setup.estateId,
              isStageMap: true,
              stageId: $setup.lots[0]?.stageId._id,
              hoverLotId: $setup.hoverLotId,
              lotsByHouseDesigns: $setup.props.lotsByHouseDesigns,
              builderView: $setup.props.builderView,
              hideOptions: $setup.props.hideMapSidePanelOptions,
              onOnLotHover: $setup.onSidePanelLotHover,
              onOnLotClick: $setup.onSidePanelLotClick,
              onToMasterplan: $setup.toMasterplan,
              onOnLotBuilderHover: $setup.onLotBuilderHover,
              onOnRegister: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('onRegister'))),
              onOnMessage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('onMessage')))
            }, null, 8, ["estateId", "stageId", "hoverLotId", "lotsByHouseDesigns", "builderView", "hideOptions"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["map-elements-container", { 'map-max-width': $setup.isEmbeddedDesktop }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["map-elements-wr", { isBuilderView: $setup.props.builderView }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["map-info-block", { 'map-info-embedded': $setup.isEmbeddedDesktop }])
            }, [
              ($setup.props.role === $setup.UserRoles.CUSTOMER && !$setup.isEmbeddedDesktop)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "button icon back-btn",
                    onClick: $setup.back
                  }))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "status gray" }, "Not Released", -1)),
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "status success" }, "Available", -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["status", $setup.props.role === $setup.UserRoles.CUSTOMER ? 'light-blue' : 'blue'])
                    }, _toDisplayString($setup.props.role === $setup.UserRoles.CUSTOMER ? "Hold" : "Pre-Contract"), 3),
                    _createElementVNode("div", _hoisted_8, _toDisplayString($setup.props.role === $setup.UserRoles.CUSTOMER ? "Under Contract" : "Contract Executed"), 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString($setup.props.role === $setup.UserRoles.CUSTOMER ? "Sold" : "Settled"), 1),
                    ($setup.props.role !== $setup.UserRoles.CUSTOMER)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "status" }, "Unconditional", -1)),
                          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "status orange" }, "Option", -1)),
                          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "status gray-middle" }, "Offline", -1))
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["zoom-container", [{ 'zoom-active': $props.zoom !== 1 && $setup.isDesktop }, { 'zoom-desktop-embedded': $setup.isEmbeddedDesktop }, { 'zoom-hidden': $setup.props.builderView }]])
            }, [
              _createElementVNode("button", {
                class: "button zoom-btn",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.emits('updateZoom', 0.2)))
              }, "+"),
              _createElementVNode("button", {
                class: "button zoom-btn",
                onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.emits('updateZoom', -0.2)))
              }, "-")
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["scroll-wrapper svg-scroll-wr", [{ 'svg-container grab': $setup.props.zoom !== 1 }, { grab: $setup.props.zoom !== 1 }]]),
              ref: "svgContainerMap",
              onMousedown: $setup.startDragging,
              onMousemove: $setup.handleDragging,
              onMouseup: $setup.stopDragging
            }, [
              _createVNode($setup["StageSvgMap"], {
                map: $setup.map,
                lots: $setup.lots,
                zoom: $setup.props.zoom,
                getTooltipText: $setup.getSvgTooltipText,
                getItemWrClasses: $setup.getSvgItemWrClasses,
                getItemPathClasses: $setup.getSvgItemPathClasses,
                getItemStatusPathClasses: $setup.getSvgItemStatusPathClasses,
                onOnLotHover: $setup.onLotHover,
                onOnLotLeave: $setup.onLotLeave,
                onOnLotClick: $setup.handleLotClickIfClickable
              }, null, 8, ["map", "lots", "zoom"])
            ], 34)
          ], 2),
          (!$setup.isDesktop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "status gray" }, "Not Released", -1)),
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "status success" }, "Available", -1)),
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "status light-blue" }, "Hold", -1)),
                _createElementVNode("div", _hoisted_11, _toDisplayString($setup.props.role === $setup.UserRoles.CUSTOMER ? "Under Contract" : "Contract Executed"), 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString($setup.props.role === $setup.UserRoles.CUSTOMER ? "Sold" : "Settled"), 1),
                ($setup.props.role !== $setup.UserRoles.CUSTOMER)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "status" }, "Unconditional", -1)),
                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "status orange" }, "Option", -1)),
                      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "status gray-middle" }, "Offline", -1))
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 2),
        ($setup.isEmbeddedDesktop && !$setup.props.builderView)
          ? (_openBlock(), _createBlock($setup["MapSideLegend"], {
              key: 1,
              isEstateMap: false,
              role: $setup.props.role
            }, null, 8, ["role"]))
          : _createCommentVNode("", true)
      ], 2)
    ], 2)
  ], 34))
}